
function TierSvgLayer(svgLayer) {
	return (
		<div
			style={{ width: '100%', height: '100%' }}
			dangerouslySetInnerHTML={{ __html: svgLayer.svgLayer }}
		/>
	);
}

export default TierSvgLayer;
